import React, { useState } from 'react'
import { Tab, Tabs } from '@material-ui/core'
import SummaryContainer from '../partials/SummaryContainer'
import StoriesTable from './StoriesTable'
import { observer } from 'mobx-react'
import { inject } from 'mobx-react'
import { flow } from 'lodash'
import { IStore } from '../../../../store/models'
import { IUser } from '../../../../store/models/User'
import { RouteComponentProps, withRouter } from 'react-router'

interface Props {
  user?: IUser
  visibleScope: 'all' | 'pending'
  setVisibleScope(val: 'all' | 'pending'): void
  loadFilter(arg): void
}

/**
 * Same two-tab shape as the Topics table's Active/Archived, and for the same
 * reason: it is one list, one pager and one sort, scoped. The scope lives on
 * the store, `loadFilter` re-asks the server for the narrowed slice, and the
 * table redraws.
 *
 * "Awaiting approval" is worded as what the record can actually prove. Stories
 * submitted from a topic QR card arrive `visible: false`, but so does any
 * story an admin has hidden by hand -- `visible` is the only reviewed-ness the
 * schema carries, so this tab is every hidden story, of which the never-yet
 * -approved ones are a subset.
 */
const StoriesSummary = ({ user, history, visibleScope, setVisibleScope, loadFilter }: Props & RouteComponentProps) => {
  const [index, setIndex] = useState(visibleScope === 'pending' ? 1 : 0)

  return (
    <div>
      <SummaryContainer title='Stories' id='ic-admin-stories'>
        <Tabs
          value={index}
          onChange={(e, val) => {
            setIndex(val)
            setVisibleScope(val === 1 ? 'pending' : 'all')
            loadFilter({ reset: true, clear: true })
          }}
          indicatorColor='primary'
          textColor='primary'
          variant='fullWidth'
          centered
        >
          {/*
            * Not wrapped in a Tooltip: MUI's Tabs clones its direct children to
            * hand them `selected`/`value`/`onChange`, so a wrapper swallows
            * them and the tab stops highlighting.
            */}
          <Tab label='All Stories' />
          <Tab label='Awaiting approval' />
        </Tabs>
        <StoriesTable />
      </SummaryContainer>
    </div>
  )
}

export default flow(
  withRouter,
  observer,
  inject<FIXME, FIXME>(
    ({
      mst: {
        auth: { user },
        stories: { visibleScope, setVisibleScope, loadFilter }
      }
    }: {
      mst: IStore
    }) => {
      return {
        user,
        visibleScope,
        setVisibleScope,
        loadFilter
      }
    }
  )
)(StoriesSummary)
